<template>
  <div>
    <!-- Dados chegaram e o trecho está arquivado -->
    <OJumbo v-if="tripIsArchived" icon="mdi-history" class="mt-8">
      <h1>Este trecho está arquivado.</h1>
      <div class="mt-8">
        ID do trecho:
        <div class="error-detail mono">
          <!-- {{ orgCode }} / -->{{ tripId }}</div>
      </div>
    </OJumbo>

    <!-- Dados chegaram e o usuário não tem permissão -->
    <OJumbo v-else-if="tripNotVisible" triangle class="mt-8">
      <h1>Este trecho não está visível para o seu perfil.</h1>
    </OJumbo>

    <!-- Dados não chegaram ou chegaram com erro -->
    <OJumbo v-else bang class="mt-8">
      <h1>Não foi possível recuperar os detalhes deste trecho.</h1>
      <div v-if="reqId != null" class="mt-8">
        <div class="error-detail mono">reqId: {{ reqId }}</div>
      </div>
      <pre class="mt-8">{{ err.reason }}</pre>
      <pre class="stack">{{ err.stack }}</pre>
    </OJumbo>
  </div>
</template>

<script>
export default {
  props: {
    err: { required: true },
    tripId: { required: true },
    orgCode: { required: true }
  },
  computed: {
    tripIsArchived() {
      return this.err.reason == 'MissingRawdata'
    },
    tripNotVisible() {
      return this.err.status == 403
    },
    reqId() {
      return this.err.reqId
    }
  }
}
</script>

<style lang="sass">
pre.stack
  text-align: left
  font-size: 10pt
  max-width: calc(100vw - 100px)
  overflow: auto
</style>
